import React from 'react';
import { motion } from 'framer-motion';
import { Highlight } from './Heading';
import { SectionHeader } from './SectionHeader';
import { Reveal } from './Reveal';
import { InitiativesShowcase } from './InitiativesShowcase';
import { pillars } from '../data/about';
import type { Pillar } from '../types/landing';
const toneStyles: Record<Pillar['tone'], {
  card: string;
  icon: string;
  text: string;
}> = {
  navy: {
    card: 'bg-primary text-white',
    icon: 'bg-white/15 text-accent-gold',
    text: 'text-white/85'
  },
  gold: {
    card: 'bg-accent-gold text-[#2A2104]',
    icon: 'bg-white/35 text-primary',
    text: 'text-[#2A2104]/85'
  },
  maroon: {
    card: 'bg-secondary-maroon text-white',
    icon: 'bg-white/15 text-accent-gold',
    text: 'text-white/85'
  },
  gray: {
    card: 'bg-[#4A5160] text-white',
    icon: 'bg-white/15 text-accent-gold',
    text: 'text-white/85'
  }
};
export function FootprintSection() {
  return <section id="huella" className="bg-muted-background/60 py-16 md:py-20" data-id="element-266" data-mp="30ghw0ljc40vn">
      <div className="mx-auto max-w-7xl px-6" data-id="element-267" data-mp="30ef94adhanv5">
        <SectionHeader eyebrow="Nuestra huella" title={<>
              Tres periodos <Highlight tone="accent" data-id="element-269" data-mp="1cq4psp8p0c8u">construyendo región</Highlight>
            </>} subtitle="Durante tres periodos consecutivos hemos sido miembros activos de la Junta Directiva de la Cámara de Comercio de Cali, aportando conocimiento y criterio empresarial a decisiones estratégicas para el fortalecimiento institucional y el desarrollo regional." data-id="element-268" data-mp="18oszehhzvmzl" />
        <Reveal delay={0.1} className="mt-4 max-w-3xl" data-id="element-270" data-mp="trtk07gwipuk">
          <p className="text-base leading-relaxed text-foreground/70 md:text-lg" data-id="element-271" data-mp="tuen0zsxrbtw">
            Hemos contribuido a la articulación de iniciativas estratégicas para el territorio, como el{' '}
            <strong className="font-semibold text-primary" data-id="element-272" data-mp="13oogylxj0i6q">
              proyecto clúster MRO (Mantenimiento, reparación y overhaul de aeronaves)
            </strong>
            , impulsado desde espacios directivos de la Cámara de Comercio de Cali e Invest Pacific, y que busca abrir
            oportunidades para el desarrollo de una cadena de valor especializada.
          </p>
        </Reveal>

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4" data-id="element-273" data-mp="1kksbbq2gk8ye">
          {pillars.map((p, i) => {
          const s = toneStyles[p.tone];
          return <Reveal key={p.number} delay={i * 0.08} className="h-full" data-id="element-274" data-mp="1uhewkfyp520y" data-mpi={i}>
                <motion.article whileHover={{
              y: -8
            }} transition={{
              type: 'spring',
              stiffness: 300,
              damping: 22
            }} className={`flex h-full flex-col items-center rounded-[24px] px-6 py-9 text-center ${s.card}`} data-id="element-275" data-mp="16qhr9m1ep2yo">
                  <span className={`flex h-20 w-20 items-center justify-center rounded-3xl ${s.icon}`} data-id="element-276" data-mp="1bpuh8fnkqq5h">
                    <p.icon className="h-10 w-10" strokeWidth={1.75} data-id="element-277" data-mp="o09ynxvc1uwq" />
                  </span>
                  <h3 className="type-h4 mt-6 uppercase tracking-wide" data-id="element-278" data-mp="j28flcxwpvl9">
                    {p.title}
                  </h3>
                  <p className={`mt-3 text-base leading-relaxed md:text-[17px] ${s.text}`} data-id="element-279" data-mp="2uoa7lbwvdva8">{p.description}</p>
                </motion.article>
              </Reveal>;
        })}
        </div>

        <InitiativesShowcase data-id="element-280" data-mp="2ks75u75xjynt" />
      </div>
    </section>;
}